import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { ResourcedEmoji } from '@atlaskit/emoji';
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { jsx } from '@emotion/react';
import { containerStyle, reactionParticleStyle } from './styles';
export var PARTICLE_COUNT = 4;
export var ReactionParticleEffect = function ReactionParticleEffect(_ref) {
  var emojiProvider = _ref.emojiProvider,
    emojiId = _ref.emojiId;
  return (
    // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    jsx("div", {
      css: containerStyle
    }, _toConsumableArray(Array(PARTICLE_COUNT)).map(function (_, index) {
      return (
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        jsx("div", {
          key: index,
          css: reactionParticleStyle
        }, jsx(ResourcedEmoji, {
          emojiProvider: emojiProvider,
          emojiId: emojiId,
          fitToHeight: 16
        }))
      );
    }))
  );
};